// extracted by mini-css-extract-plugin
export default {"layout":"amNQn1","layoutContent":"bmNQn1"};